import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import AsyncAiAgentConfigsViewList from './components/configs/AiAgentConfigsView';
import {
	addBlockDevelopment,
	addExtensionDevelopment,
	addPageDevelopment,
} from './development';
import { configureSafRegistrySdk } from './http';
import { setLogger } from './logger';
import { extensionSlots } from './types';

export function setup(piletApi: PiletApi) {
	setLogger(piletApi.sf.getLogger());

	configureSafRegistrySdk(piletApi);
	piletApi.registerExtension(extensionSlots.aiAgentConfigsExtension, props => (
		<AsyncAiAgentConfigsViewList {...props} />
	));

	if (process.env.NODE_ENV === 'development') {
		addBlockDevelopment(piletApi);
		addPageDevelopment(piletApi);
		addExtensionDevelopment(piletApi);
	}
}
